import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import Divider from "@mui/material/Divider";
import { styled } from "@mui/material/styles";
import {
  leaveWaitlist,
  getWaitTicketById,
  getLastUpdateTime,
} from "../../apis";
import { ClientOutlinedButton } from "../../components/button";
import { updateEditValue } from "../../store/slices/waitlist";
import { useDispatch, useSelector } from "react-redux";
import { setWarning, showAlert } from "../../store/slices/feedback";

const DashedDivider = styled(Divider)`
  border-style: dashed;
`;

const useStyles = makeStyles({
  name: {
    fontSize: "20px",
    fontFamily: "Roboto",
    color: "#fff",
    textAlign: "center",
    marginBottom: 31,
    height: 23,
  },
  stars: {
    height: 134,
    margin: "0 auto",
    width: "68%",
    marginLeft: "13%",
  },
  ticket: {
    width: "calc(100% - 60px)",
    height: "527px",
    margin: "0px auto",
    marginTop: 30,
    backgroundColor: "#fff",
    paddingTop: 30,
    textAlign: "center",
    borderRadius: 10,
  },
  waitingNumber: {
    width: "74px",
    height: "74px",
    margin: "0 auto",
    padding: "18px 17px 14px 18px",
    borderRadius: "60px",
    backgroundColor: "#FFA439",
    lineHeight: "74px",
    fontFamily: "Avenir",
    fontSize: "31px",
    color: "#fff",
  },
  isYourNumber: {
    marginTop: 7,
    fontSize: 20,
    color: "#1c1939",
  },
  position: {
    height: "42px",
    lineHeight: "42px",
    fontFamily: "Avenir",
    fontSize: "20px",
    color: "#000",
    marginTop: 116,
  },
  positionNumber: {
    fontSize: 31,
    fontWeight: 500,
    color: "#7A92A5",
  },
  partySize: {
    fontFamily: "Avenir",
    fontSize: "18px",
    color: "#6c727c",
    margin: "0 auto",
    width: 243,
  },
  button: {
    marginTop: "99px",
  },
  tearHere: {
    position: "relative",
  },
  // tearHereLeft: {
  //   width: "26px",
  //   height: "26px",
  //   backgroundColor: "#BEC2C5",
  //   borderRadius: "25px",
  //   position: "absolute",
  //   left: "-13px",
  // },
  // tearHereRight: {
  //   width: "26px",
  //   height: "26px",
  //   backgroundColor: "#B6C0C2",
  //   borderRadius: "25px",
  //   position: "absolute",
  //   right: "-13px",
  // },
  divider: {
    position: "absolute",
    top: "13px",
    left: "30px",
    width: "calc(100% - 60px)",
  },
});

export default ({}) => {
  const search = useLocation().search;
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { merchantId } = useParams();
  const merchant = useSelector((state) => state.merchant);
  const id = new URLSearchParams(search).get("id");
  const [firstload, setFirstload] = useState(false);
  const [ticket, setTicket] = useState({
    waitingNumber: "",
    position: "",
    basedOnRules: "",
    tableIsReady: false,
    isWaiting: true,
    status: "",
    allPosition: "",
  });

  const [heartbeat, setHeartbeat] = useState(Date.now());
  const [lastUpdateTime, setLastUpdateTime] = useState(null);
  useEffect(() => {
    if (!firstload && id) {
      loadWaitTicket();
      setFirstload(true);
    }

    async function loadWaitTicket() {
      const wait = await getWaitTicketById(id);
      const allPosition = wait?.data?.position;
      const {
        waitingNumber,
        positionInTableType,
        tableType,
        tableIsReady = false,
        isWaiting,
        status,
      } = wait.data;
      let basedOnRules = tableType.name;
      basedOnRules += " (";
      if (tableType.min) {
        basedOnRules += tableType.min;
      }
      if (tableType.max) {
        basedOnRules = basedOnRules + "~" + tableType.max;
      } else {
        basedOnRules += "+";
      }
      basedOnRules += ")";
      setTicket({
        waitingNumber,
        position: positionInTableType,
        basedOnRules,
        tableIsReady,
        isWaiting,
        status,
        allPosition,
      });
    }

    const interval = setInterval(async () => {
      const now = Date.now();
      const refreshInterval = 1000 * 5;
      if (now > heartbeat + refreshInterval) {
        try {
          let fetchLastUpdateTime = await getLastUpdateTime(merchantId);
          const newLastUpdate = fetchLastUpdateTime.data.lastUpdateTime;
          if (lastUpdateTime !== newLastUpdate) {
            setLastUpdateTime(newLastUpdate);
            loadWaitTicket();
          }
        } catch (err) {
          console.log(err);
          dispatch(showAlert("Failed to load data. "));
        }
        setHeartbeat(now);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  });
  const onLeave = async () => {
    const onConfirm = async () => {
      await leaveWaitlist(id);
      dispatch(updateEditValue({ partySize: "", name: "", phone: "" }));
      navigate(`/${merchantId}/client/start`);
    };
    dispatch(
      setWarning({
        on: true,
        title: "Leave waitlist",
        message: `Once you leave waitlist, you need to requeue if you want to join again`,
        actionTitle: "Leave",
        onConfirm: onConfirm,
      }),
    );
  };

  const renderCurrentStatus = () => {
    const { isWaiting, status } = ticket;
    if (!isWaiting && status) {
      if (status === "SEATED") {
        return <div className={classes.position}>You are seated.</div>;
      }
      if (["CANCELED", "LEFT"].includes(status)) {
        return (
          <div className={classes.position}>
            You’ve been removed from our waitlist.
          </div>
        );
      }
    }
    return null;
  };

  const renderCurrentTicketInfo = () => {
    const { isWaiting, tableIsReady, allPosition } = ticket;
    if (!isWaiting) return null;
    if (tableIsReady)
      return (
        <div className={`${classes.positionNumber} ${classes.position}`}>
          Table is ready
        </div>
      );
    return (
      <div className={classes.position}>
        <span>You are </span>
        <span className={classes.positionNumber}>{ordinal(allPosition)}</span>
        <span> in line</span>
      </div>
    );
  };

  const renderBottomInfo = () => {
    const { isWaiting, basedOnRules } = ticket;
    if (!isWaiting) return null;
    return (
      <>
        <div className={classes.partySize}>{`Based on all party sizes `}</div>
        <div className={classes.button}>
          <ClientOutlinedButton onClick={onLeave}>
            Leave waitlist
          </ClientOutlinedButton>
        </div>
      </>
    );
  };

  return (
    <div>
      <div className={classes.name}>{merchant ? merchant.name : ""}</div>
      <div className={classes.ticket}>
        <div className={classes.waitingNumber}>{ticket.waitingNumber}</div>
        <div className={classes.isYourNumber}>is your waiting number</div>
        <div className={classes.tearHere}>
          <div className={classes.divider}>
            <DashedDivider />
          </div>
        </div>
        {renderCurrentStatus()}
        {renderCurrentTicketInfo()}
        {renderBottomInfo()}
      </div>
    </div>
  );
};

function ordinal(number) {
  const english_ordinal_rules = new Intl.PluralRules("en", {
    type: "ordinal",
  });
  const suffixes = {
    one: "st",
    two: "nd",
    few: "rd",
    other: "th",
  };
  const suffix = suffixes[english_ordinal_rules.select(number)];
  return number + suffix;
}
